module.exports = __webpack_public_path__ + "static/media/add.fce9ac00.svg";